import { Typography } from 'antd';
import ReactMarkdown from 'react-markdown';
import { space } from '@viq-admin/ui';
import guide from './guide.md?raw';
import assembly from './sections/assembly.md?raw';
import output from './sections/output.md?raw';
import writing from './sections/writing.md?raw';

/** Same sections the authoring screens show in collapsible panels — one source. */
const REFERENCE: Array<{ heading: string; body: string }> = [
  { heading: 'How the full prompt is assembled', body: assembly },
  { heading: 'What the AI returns', body: output },
  { heading: 'Writing a good prompt', body: writing },
];

/**
 * Operator guide for the AI prompt screens (epic viq-backend#41).
 *
 * The content lives in `guide.md` and is imported raw at build time — revising
 * the guide is a plain-text edit with no React involved. antd's base
 * `<Typography>` styles the native elements react-markdown emits (headings,
 * lists, tables, code), so the page inherits console theming for free.
 *
 * Deliberately no heading anchors: react-markdown v9 does not generate heading
 * ids without `rehype-slug`, so the "How this works" links on the prompt screens
 * point at the page, not a section. Add the plugin if the guide grows enough to
 * need deep links.
 */
export function PromptGuide() {
  return (
    <div data-testid="prompt-guide">
      <Typography style={{ maxWidth: 820 }}>
        <div style={{ marginBottom: space.lg }}>
          <ReactMarkdown>{guide}</ReactMarkdown>
        </div>
        {REFERENCE.map((s) => (
          <div key={s.heading} style={{ marginBottom: space.lg }}>
            <hr />
            <h2>{s.heading}</h2>
            <ReactMarkdown>{s.body}</ReactMarkdown>
          </div>
        ))}
      </Typography>
    </div>
  );
}
